import React, { FC, ReactNode, useState } from "react";
import { Modal, ModalHeader, ModalBody, ModalFooter, Button } from "reactstrap";
import { DeleteIcon } from "./Icons";

export const DeleteModal: FC<{
  onConfirm: () => void;
  title: string;
  children?: ReactNode;
}> = ({ onConfirm, title, children }) => {
  const [open, setOpen] = useState(false);

  return (
    <>
      <span className="btn btn-outline-danger" onClick={() => setOpen(true)}>
        <DeleteIcon />
      </span>

      <Modal isOpen={open}>
        <ModalHeader>Delete {title}?</ModalHeader>
        <ModalBody>{children}</ModalBody>
        <ModalFooter>
          {" "}
          <span className="btn btn-link" onClick={() => setOpen(false)}>
            Cancel
          </span>{" "}
          <Button color="primary" onClick={() => onConfirm()}>
            Confirm
          </Button>
        </ModalFooter>
      </Modal>
    </>
  );
};
